import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./reward_points_display_mode.js";
//#region src/reward_points_display_mode_helper.ts
var reward_points_display_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "hide": return "Hide";
		case "show-in-label": return "Show in reward name";
		case "show-as-pill": return "Show as pill below name";
	}
}
//#endregion
export { name, reward_points_display_mode_helper_exports };

//# sourceMappingURL=reward_points_display_mode_helper.js.map